export const PRODUCT_CATEGORY_STORE = 'PRODUCT_CATEGORY_STORE';
export const PRODUCT_CATEGORY_UPDATE = 'PRODUCT_CATEGORY_UPDATE';
export const PRODUCT_CATEGORY_DESTROY = 'PRODUCT_CATEGORY_DESTROY';
